import React from "react";
import {Checkboxes} from "mui-rff";
import {Checkbox as MuiCheckbox, FormControlLabel} from '@mui/material';
import {ReactComponent as Icon} from "../../../../assets/images/check-box/checkbox.svg";
import {ReactComponent as IconCheckbox} from "../../../../assets/images/check-box/checkbox-active.svg";
import classnames from "classnames";


export const CheckboxForm = ({
                                 required,
                                 label,
                                 data,
                                 name,
                                 helperText,
                                 className = '',
                                 ...props
                             }) => {

    return (
        <Checkboxes
            className={`checkbox ${className}`}
            color={'primary'}
            icon={<Icon/>}
            checkedIcon={<IconCheckbox/>}
            required={required}
            label={label}
            data={data}
            name={name}
            value={true}
            helperText={helperText}
            {...props}
        />
    );
}

export const Checkbox = ({
                             label,
                             name,
                             disabled,
                             indeterminate = false,
                             checked,
                             value = checked,
                             onChange,
                             defaultChecked,
                             defaultValue = defaultChecked,
                             labelClassName,
                             className,
                             formControlLabelProps,
                             ...props
                         }) => {


    return (
        <FormControlLabel
            name={name}
            label={label ?? undefined}
            disabled={disabled}
            value={value}
            checked={checked}
            className={labelClassName}
            control={
                <MuiCheckbox
                    icon={<Icon/>}
                    checkedIcon={<IconCheckbox/>}
                    defaultChecked={defaultChecked}
                    defaultValue={defaultValue}
                    className={classnames('checkbox', className)}
                    color={'primary'}
                    name={name}
                    value={value}
                    onChange={onChange}
                    checked={checked}
                    disabled={disabled}
                    indeterminate={indeterminate}
                    {...props}
                />
            }
            {...formControlLabelProps}
        />

    );
}

/**
 * @param {import('@mui/material').CheckboxProps} props
 */
export const StandaloneCheckbox = ({...props}) => {
    return (
        <MuiCheckbox
            icon={<Icon/>}
            checkedIcon={<IconCheckbox/>}
            color={'primary'}
            {...props}
        />
    );
}
